import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import { formatPopularity } from '@/utils/movies';

interface MovieCardProps {
  movie: Movie;
  showPopularity?: boolean;
}

export default function MovieCard({ movie, showPopularity = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100 transition duration-300 hover:-translate-y-1 hover:border-accent-400/70"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '2 / 3' }}>
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 电影在线观看与剧情介绍`}
          className="h-full w-full object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90"></div>

        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-secondary-500/95 px-2 py-0.5 text-xs font-bold text-background-50 dark:text-foreground-950">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>

        {showPopularity && (
          <span className="absolute right-2 top-2 rounded-full bg-background-950/70 px-2 py-0.5 text-[11px] font-medium text-foreground-900 backdrop-blur">
            {formatPopularity(movie.popularity)} 次观看
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="truncate text-sm font-semibold text-foreground-950">{movie.title}</h3>
          <p className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
            <span>{movie.year}</span>
            <span className="h-1 w-1 rounded-full bg-foreground-400"></span>
            <span className="truncate">{movie.genres.join(' · ')}</span>
          </p>
        </div>
      </div>
    </Link>
  );
}